<template>
    <main class="home-page">
        <div class="home-page-header flex flex-vertical-center flex-between">
            <div class="flex flex-vertical-center">
                <img src="@images/logo.png" class="logo" alt="" @click="toHk" />
                <img src="@images/base/catchphrase.png" class="catchphrase" alt="" />
            </div>
            <input
                v-if="!loginState"
                type="button"
                value="去登录"
                class="to-login"
                @click="toLogin"
            />
            <div v-else class="login-part flex flex-vertical-center">
                <router-link
                    :to="{ name: 'UserCenter' }"
                    class="to-usercenter flex flex-vertical-center"
                >
                    <span class="user-avatar-container">
                        <img :src="userInfo.avatar" alt="" class="user-avatar" />
                    </span>
                    <span class="username">{{ userInfo.real_name }}</span>
                </router-link>
                <span class="log-out" @click="handleLogout">退出</span>
            </div>
        </div>
        <el-carousel class="banner" indicator-position="inside" height="448px" arrow="never">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item.image_url" alt="" />
            </el-carousel-item>
        </el-carousel>
        <div class="bg">
            <div class="home-page-center">
                <div class="container-center-top flex flex-between flex-vertical-center">
                    <h3 class="live-foreshow-title"><span>直播</span>预告</h3>
                    <div class="more">
                        <router-link :to="{ name: 'Home' }" class="flex">
                            更多
                            <p></p>
                        </router-link>
                    </div>
                </div>
                <div v-if="liveList.length !== 0" class="mt20 c-junior-grid4">
                    <c-course-card
                        v-for="course in liveList"
                        :key="course.id"
                        :name="course.name"
                        :tags="[course.subject_name, course.grade_name]"
                        :play-count="getReserveCount(course.lives.data)"
                        :avatar="course.avatar || defaultImg"
                        :course-time="course.show_time_str"
                        :username="course.teacher_name"
                        :price="course.price || 0"
                        :free="course.free"
                        :bought="course.bought"
                        :audition="false"
                        :play-count-in-center="false"
                        :state="course.status"
                        status-text="预约"
                        @click.native="toHome"
                    ></c-course-card>
                </div>
                <div v-else class="no-replay flex flex-column flex-center flex-vertical-center">
                    <img src="@images/base/no-lesson.png" alt="" class="no-replay-img" />
                    <p class="no-replay-text">暂无直播哦~</p>
                </div>
            </div>
        </div>
        <div class="home-page-container">
            <div v-if="replayList.length > 0" class="container-center">
                <div class="container-center-top flex flex-between flex-vertical-center">
                    <h3 class="replay-title"><span>课程</span>回放</h3>
                    <div class="more">
                        <router-link :to="{ name: 'ReplayList' }" class="flex">
                            更多
                            <p></p>
                        </router-link>
                    </div>
                </div>
                <div class="replay-list">
                    <ul class="replay-list-container">
                        <li
                            v-for="(item, index) in replayList"
                            :key="index"
                            class="replay-item flex flex-column flex-between"
                        >
                            <div class="replay-base-info">
                                <h3 class="replay-base-info-title">{{ item.name }}</h3>
                                <p class="flex">
                                    <span class="grade">{{ item.grade_name }}</span>
                                    <span class="subject">{{ item.subject_name }}</span>
                                    <span class="teacher-name">{{ item.teacher_name }}</span>
                                </p>
                            </div>
                            <p class="time">{{ item.show_time_str }}</p>
                            <a target="_blank" class="play-container" @click="recordReplay(item)">
                                <i class="play-icon"></i>
                            </a>
                        </li>
                    </ul>
                    <!-- <div class="no-replay flex flex-column flex-center flex-vertical-center">
                        <img src="@images/base/no-lesson.png" alt="" class="no-replay-img" />
                        <p class="no-replay-text">暂无课程，直播结束后就有回放哦</p>
                    </div> -->
                </div>
            </div>
            <div class="mt28 container-center-top flex flex-between flex-vertical-center">
                <h3 class="replay-title">公开课</h3>
                <div class="more">
                    <router-link :to="{ name: 'PublicClass' }" class="flex">
                        更多
                        <p></p>
                    </router-link>
                </div>
            </div>
            <div class="mt20 c-junior-grid4">
                <c-course-card
                    v-for="course in courseList"
                    :key="course.id"
                    :name="course.name"
                    :tags="[course.subject_name, course.grade_name]"
                    :play-count="course.views"
                    :avatar="course.avatar || defaultImg"
                    :course-time="course.show_time_str"
                    :username="course.teacher_name"
                    :price="course.price || 0"
                    :free="course.free"
                    :bought="course.bought"
                    :audition="false"
                    :play-count-in-center="false"
                    :state="course.status"
                    @click.native="toCourseDetail(course)"
                ></c-course-card>
            </div>
        </div>
        <c-teacher-recommend></c-teacher-recommend>
        <div>
            <div class="home-page-container home-page-contianer2">
                <!-- <h2 class="first-title">不跑辅导班，与巴蜀师生一起学</h2>
                <p class="second-title">市教委直属重点中学，87年办学历史让您放心</p> -->
                <div class="famous-school-container flex flex-vertical-center flex-between">
                    <h3>名校联盟</h3>
                    <ul class="flex flex-vertical-center school-logo">
                        <li>
                            <a target="_blank" href="http://www.bashu.cn/">
                                <img src="@images/base/bashu.png" alt="" />
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.tsinghua.edu.cn/"
                                ><img src="@images/base/qinghua.png" alt=""
                            /></a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.pku.edu.cn/"
                                ><img src="@images/base/beijing.png" alt=""
                            /></a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.cqwb.com.cn/"
                                ><img src="@images/base/wanbao.png" alt=""
                            /></a>
                        </li>
                        <li>
                            <a target="_blank" href="http://cq.people.com.cn/"
                                ><img src="@images/base/renmin.png" alt=""
                            /></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <hk-footer theme="dark"></hk-footer>
    </main>
</template>

<script>
import HkFooter from '@components/HkFooter';
import {
    getHomeBannerList,
    getHomeLiveList,
    getHomeReplayList,
    queryOpenCourseList
} from '@api/homepage';
import { getUserInfo } from '@api/userInfo';
import store from '@store/index';
import { isNotEmpty } from '@helpers/validation';
import defaultImg from '@images/base/header-exam.png';
import { mapActions } from 'vuex';
import CTeacherRecommend from '@components/CTeacherRecommend.vue';
import CCourseCard from '@components/CCourseCard.vue';

export default {
    name: 'HomePage',
    components: {
        HkFooter,
        CTeacherRecommend,
        CCourseCard
    },
    data() {
        return {
            bannerList: [],
            liveList: [],
            defaultImg,
            userInfo: {
                avatar: defaultImg,
                real_name: ''
            },
            buttonStyle: {
                width: '120px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            replayList: [],
            grade: [
                '一年级',
                '二年级',
                '三年级',
                '四年级',
                '五年级',
                '六年级',
                '初一',
                '初二',
                '初三',
                '高一',
                '高二',
                '高三'
            ],
            courseList: []
        };
    },

    computed: {
        loginState() {
            return !!isNotEmpty(store.getters.token);
        }
    },

    created() {
        this.initData();
    },

    mounted() {},

    methods: {
        ...mapActions(['logout']),
        getReserveCount(lives = []) {
            return lives.reduce((prev, current) => {
                if (current.reserve_count) {
                    return prev + Number(current.reserve_count);
                }
                return prev;
            }, 0);
        },
        initData() {
            this.getBanner();
            this.getLiveListData();
            this.getReplay();
            this.getOpenCourseList();
            this.getHomeUserInfo();
        },
        async getOpenCourseList() {
            const { data = [] } = await queryOpenCourseList({ limit: 4 });
            this.courseList = data;
        },
        getBanner() {
            getHomeBannerList().then((res) => {
                this.bannerList = res.data;
            });
        },
        getLiveListData() {
            getHomeLiveList().then((res) => {
                this.liveList = res.data;
            });
        },
        getReplay() {
            getHomeReplayList().then((res) => {
                this.replayList = res.data.slice(0, 8);
            });
        },
        toUserCenter() {
            this.$router.push({ name: 'UserCenter' });
        },
        toHome() {
            this.$router.push({ name: 'Home' });
        },
        getHomeUserInfo() {
            if (this.loginState) {
                getUserInfo().then((res) => {
                    this.userInfo = res.data;
                });
            }
        },
        toHk() {
            window.open('http://www.51haoke.com/');
        },
        recordReplay(item) {
            // console.log(this)
            // this.$router.push({ name: 'PlaybackPlayer', query: { id: item.id } });
            this.isLogin(item.id);
            this.$trackEvent('视频回放', '进入视频回放', item.id);
        },
        toCourseDetail({ id }) {
            this.$trackEvent('公开课', '进入公开课播放', id);
            this.$router.push({
                name: 'PlaybackPlayer',
                query: {
                    id: id
                }
            });
        },
        toLogin() {
            this.$router.push({ name: 'Login' });
        },
        handleLogout() {
            this.$store.dispatch('logout', true);
        },
        isLogin(id) {
            const token = store.getters.token;
            console.log(this.$route);
            if (!isNotEmpty(token)) {
                this.$router.push({
                    name: 'Login',
                    query: {
                        redirectUrl: `/video/playback?id=${id}`
                    }
                });
            } else {
                this.$router.push({ name: 'PlaybackPlayer', query: { id: id } });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.home-page {
    width: 100%;
    min-width: 1200px;
    background: #fff;
    .bg {
        background-color: #f7f7f8;
    }
    &-header {
        width: 1200px;
        height: 60px;
        margin: 0 auto;
        .logo {
            height: 40px;
            width: 121px;
            margin-right: 19px;
            cursor: pointer;
        }
        .catchphrase {
            width: 351px;
            height: 16px;
        }
        .to-login {
            width: 68px;
            height: 26px;
            border-radius: 13px;
            border: none;
            outline: none;
            background: #7f008f;
            color: #fff;
            font-size: 12px;
            cursor: pointer;
        }
        .to-usercenter {
            text-decoration: none;
            .user-avatar-container {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 10px;
                overflow: hidden;
                border: 1px solid #e5e5e5;
            }
            .user-avatar {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .username:hover {
            color: #7f008f;
        }
        .username,
        .log-out {
            font-size: 14px;
            font-family: 'PingFang SC';
            font-weight: 500;
            color: #333333;
        }
        .log-out {
            margin-left: 8px;
            color: #ec4444;
            cursor: pointer;
        }
    }
    &::v-deep {
        .banner {
            width: 100%;
            min-width: 1200px;
            .el-carousel__item {
                display: flex;
                justify-content: center;
            }
            img {
                object-fit: cover;
                width: 100%;
                display: inline-block;
            }
        }
    }
    &-center {
        width: 1200px;
        margin: 0 auto;
        padding: 28px 0;
    }
    &-container {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 60px;
    }
    .live-foreshow {
        margin-top: 31px;
        position: relative;
        width: 790px;
        overflow: hidden;
        &-title {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #322d33;
            span {
                color: #7f008f;
            }
        }
    }
    .no-lesson {
        width: 790px;
        height: 141px;
        border-radius: 4px;
        background-color: #f7f7f7;
        margin-top: 31px;
        &-img {
            width: 73px;
            height: 76px;
            margin-right: 10px;
        }
        &-text {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #322d33;
        }
    }
    .user-center {
        width: 400px;
        height: 226px;
        &-content {
            a {
                text-decoration: none;
            }
        }
        .title-img {
            width: 100%;
            height: 51px;
            background: url('~@images/base/user-center-bg.png') no-repeat center;
        }
        .user-header {
            box-sizing: border-box;
            width: 66px;
            height: 66px;
            background: #fff;
            box-shadow: 0px 2px 6px 0px rgba(197, 200, 201, 0.8);
            border-radius: 50%;
            padding: 5px;
            margin-right: 15px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .login-text {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #848484;
            a {
                color: #7f008f;
                text-decoration: none;
            }
        }
        .log-out {
            color: #7f008f;
            margin-left: 10px;
            cursor: pointer;
        }
        .center-item {
            width: 124px;
            height: 76px;
            background: #f7f7f8;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
            a {
                width: 100%;
                height: 100%;
                text-decoration: none;
                p {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333;
                }
            }
            img {
                margin-bottom: 5px;
            }
        }
    }
    .container-center {
        margin-top: 40px;
        &-top {
            .replay-title {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #322d33;
                span {
                    color: #7f008f;
                }
            }
            .more {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #b1b1c3;
                cursor: pointer;
                a {
                    text-decoration: none;
                    color: #b1b1c3;
                    p {
                        width: 15px;
                        height: 15px;
                        text-align: center;
                        background: url('~@images/base/right-arrow-icon.png') no-repeat center
                            #b1b1c3;
                        background-size: 60%;
                        border-radius: 50%;
                        margin-left: 5px;
                    }
                }
            }
        }
        .replay-list-container {
            display: flex;
            flex-wrap: wrap;
            .replay-item {
                box-sizing: border-box;
                width: 290px;
                height: 152px;
                margin-bottom: 20px;
                background-color: #fff;
                border-radius: 4px;
                padding: 30px 14px 14px 18px;
                position: relative;
                background: url('~@images/base/blue-bg.png') no-repeat center bottom #fff;
                .replay-base-info {
                    &-title {
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #322d33;
                        line-height: 26px;
                        margin-bottom: 8px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    p {
                        span {
                            height: 12px;
                            line-height: 12px;
                            font-size: 12px;
                            font-family: PingFang SC;
                            font-weight: 500;
                            color: #322d33;
                        }
                        span:not(:last-child) {
                            margin-right: 10px;
                        }
                        .teacher-name {
                            border-left: 1px solid #322d33;
                            padding-left: 10px;
                        }
                    }
                }
                .time {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #888;
                }
                .play-container {
                    display: block;
                    position: absolute;
                    right: 14px;
                    bottom: 14px;
                }
                .play-icon {
                    display: block;
                    width: 40px;
                    height: 40px;
                    background: url('~@images/base/homepage-play-icon.png') no-repeat center;
                    cursor: pointer;
                }
            }
            .replay-item:nth-child(2n) {
                background-image: url('~@images/base/yellow-bg.png');
            }
            .replay-item:nth-child(3n) {
                background-image: url('~@images/base/lightblue-bg.png');
            }
            .replay-item:nth-child(4n) {
                background-image: url('~@images/base/purple-bg.png');
            }
            .replay-item:not(:nth-child(4n)) {
                margin-right: 13px;
            }
        }
        .no-replay {
            width: 1200px;
            height: 300px;
            &-text {
                font-size: 14px;
                color: #888;
            }
        }
    }
    .container-bottom {
        margin-top: 60px;
    }
    &-contianer2 {
        padding-top: 60px;
        padding-bottom: 120px;
        background: url('~@images/base/homepage-bg.png') no-repeat center -40px #fff;
        .first-title {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #322d33;
            margin-bottom: 10px;
        }
        .second-title {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #322d33;
            margin-bottom: 20px;
        }
        .famous-school-container {
            box-sizing: border-box;
            padding: 0 50px;
            height: 122px;
            background: #ffffff;
            box-shadow: 0px 10px 18px 0px #e4e2e4;
            border-radius: 10px;
            h3 {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #120d09;
            }
            .school-logo {
                li:not(:last-child) {
                    margin-right: 20px;
                }
            }
        }
    }
}
.c-junior {
    &-grid4 {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 10px 10px;
    }
}
</style>
